import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=fbc11f9e&scoped=true&"
import script from "./footer.vue?vue&type=script&lang=js&"
export * from "./footer.vue?vue&type=script&lang=js&"
import style0 from "./footer.vue?vue&type=style&index=0&lang=css&"
import style1 from "./footer.vue?vue&type=style&index=1&id=fbc11f9e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbc11f9e",
  null
  
)

export default component.exports